export enum ReservationFor {
  Myself = 'MYSELF',
  Other = 'OTHER',
}
